import { UploadCapacity } from './types';

const getSize = (value: number, capacity: UploadCapacity) => {
  if (Math.trunc(value) > 0) {
    return `${parseInt(String(Math.round(value)))} ${capacity.toUpperCase()}`;
  }
  return `0 ${capacity.toUpperCase()}`;
};

export const formatSize = (value?: number) => {
  if (!value) return `0 ${UploadCapacity.Bytes.toUpperCase()}`;

  const limit = 1024;
  const bytes = Number(value);
  const kilobytes = Math.floor(bytes / limit);
  const megabytes = Math.floor(kilobytes / limit);
  const gigabytes = Math.floor(megabytes / limit);

  if (gigabytes) return getSize(gigabytes, UploadCapacity.GigaBytes);

  if (megabytes) return getSize(megabytes, UploadCapacity.MegaBytes);

  if (kilobytes) return getSize(kilobytes, UploadCapacity.KyloBytes);

  return `${bytes} ${UploadCapacity.Bytes}`;
};
